import React from "react";

export default function ReportDefinitionHead({ name, type }) {
  return (
    <>
      <div className="report-definition-head">
        <img src={`assets/Reports/${type}.svg`} alt={type} />
        <div className="text-capitalize">{name}</div>
      </div>
    </>
  );
}
